import {
  TwoUpContent,
  FeatureCardsWithModalSlider,
  ProductListHero,
  FullBleedExperience,
  VideoSlider,
  TwoUpFeaturedCards,
  CompareSlider,
  LargeImageAndTextBlock,
  FAQ,
} from "@kohler-dsm-library/kohler-modules"
import { mapTwoUpContentProps } from "@/components/DesignSystem/mappers/twoUpContentMapper"
import { mapFeatureCardsSliderProps } from "@/components/DesignSystem/mappers/featureCardsSliderMapper"
import { mapProductListHeroProps } from "@/components/DesignSystem/mappers/productListHeroMapper"
import { mapFullBleedExperienceProps } from "@/components/DesignSystem/mappers/fullBleedExperienceMapper"
import { mapVideoSliderProps } from "@/components/DesignSystem/mappers/videoSliderMapper"
import { mapTwoUpFeaturedCardsProps } from "@/components/DesignSystem/mappers/twoUpFeaturedCardsMapper"
import { mapTwoUpContentCXPProps } from "@/components/DesignSystem/mappers/twoUpContentCXPMapper"
import mapCompareSliderProps from "@/components/DesignSystem/mappers/compareSliderMapper"
import { mapLargeImageAndTextProps } from "@/components/DesignSystem/mappers/largeImageAndTextMapper"
import { mapFAQProps } from "@/components/DesignSystem/mappers/faqcomponentMapper"
import { withSingleAccordion } from "@/components/DesignSystem/utils/faqAccordionHelper"

/**
 * Design System Component Registry
 *
 * Maps dsComponentType strings to their corresponding React components and
 * prop mappers. Used by getDSComponentForContainer to dynamically render
 * design system containers.
 *
 * @type {Object.<string, {component: React.ComponentType, mapper: Function}>}
 *
 */
export const dsComponentRegistry = {
  twoUpContent: {
    component: TwoUpContent,
    mapper: mapTwoUpContentProps,
  },
  featurecardsmodalslider: {
    component: FeatureCardsWithModalSlider,
    mapper: mapFeatureCardsSliderProps,
  },
  productlisthero: {
    component: ProductListHero,
    mapper: mapProductListHeroProps,
  },
  fullbleedexperience: {
    component: FullBleedExperience,
    mapper: mapFullBleedExperienceProps,
  },
  twoupcontent: { component: TwoUpContent, mapper: mapTwoUpContentCXPProps },
  videoslider: { component: VideoSlider, mapper: mapVideoSliderProps },
  twoupfeaturedcards: {
    component: TwoUpFeaturedCards,
    mapper: mapTwoUpFeaturedCardsProps,
  },
  compareslider: {
    component: CompareSlider,
    mapper: mapCompareSliderProps,
  },
  largeimagetextblock: {
    component: LargeImageAndTextBlock,
    mapper: mapLargeImageAndTextProps,
  },
  faqmodule: {
    // Wrapped with withSingleAccordion HOC to support controlled accordion behaviour:
    // - When singleExpansion is true, only one accordion can be open at a time
    // - Handles expandedItems from AEM to open specific accordions on page load
    component: withSingleAccordion(FAQ),
    mapper: mapFAQProps,
  },
}
